import type * as React from 'react';

function SvgIceHockey(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M2 19V17C2 16.7167 2.09583 16.4792 2.2875 16.2875C2.47917 16.0958 2.71667 16 3 16H4V20H3C2.71667 20 2.47917 19.9042 2.2875 19.7125C2.09583 19.5208 2 19.2833 2 19ZM5 20V16H9L9.85 14.05L11.45 17.55L10.6 19.45C10.5167 19.6333 10.3917 19.7708 10.225 19.8625C10.0583 19.9542 9.88333 20 9.7 20H5ZM22 19C22 19.2833 21.9042 19.5208 21.7125 19.7125C21.5208 19.9042 21.2833 20 21 20H20V16H21C21.2833 16 21.5208 16.0958 21.7125 16.2875C21.9042 16.4792 22 16.7167 22 17V19ZM19 20H14.3C14.1167 20 13.9417 19.9542 13.775 19.8625C13.6083 19.7708 13.4833 19.6333 13.4 19.45L7.325 6.15C7.09167 5.65 7.125 5.16667 7.425 4.7C7.725 4.23333 8.15 4 8.7 4C9 4 9.275 4.07917 9.525 4.2375C9.775 4.39583 9.96667 4.61667 10.1 4.9L12 9.2L13.9 4.9C14.0333 4.61667 14.2208 4.39583 14.4625 4.2375C14.7042 4.07917 14.975 4 15.275 4C15.825 4 16.2542 4.23333 16.5625 4.7C16.8708 5.16667 16.9083 5.65 16.675 6.15L13.6 12.85L15 16H19V20Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIceHockey;
